import { render } from "./PartenaireView.vue?vue&type=template&id=70b6656d"
import script from "./PartenaireView.vue?vue&type=script&lang=js"
export * from "./PartenaireView.vue?vue&type=script&lang=js"

import "./PartenaireView.vue?vue&type=style&index=0&id=70b6656d&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__